<!-- 
  This SVG definition can be placed at the top of your component's HTML.
  By defining it once in a <symbol>, we can reuse it efficiently.
-->
<svg
	width="0"
	height="0"
	style="position:absolute"
>
	<symbol
		id="moveright-logo"
		viewBox="0 0 499 138"
	>
		<!-- Updated class names to match the animation styles -->
		<path
			class="shell-logo-part-1"
			d="M159.88 60.4861C139.918 41.7482 115.69 49.9994 103.342 58.1035C102.03 58.9644 102.449 61.1774 103.858 61.8676C107.258 63.5331 112.15 66.8414 117.488 72.7466C125.468 81.5743 119.15 82.1465 114.994 81.3291C102.448 62.3482 77.9948 64.7935 66.2571 68.674C65.5645 68.903 65.0992 69.5604 65.0571 70.2886C63.89 90.4767 57.9988 86.1388 55.1457 81.3291C57.2238 76.8335 60.6318 64.8997 57.6394 53.1294C54.6469 41.3591 58.8862 35.147 61.3799 33.5123C71.3546 44.3017 78.8357 35.556 81.3294 29.8345C89.3845 10.0324 70.8778 3.28963 54.7012 1.8582C47.8788 1.25449 41.4948 4.7315 37.7549 10.4694C30.671 21.3377 19.9527 39.7794 9.01233 64.1646C-5.94978 97.5137 2.77812 112.39 9.01233 115.66C69.8582 149.009 134.943 129.555 159.88 115.66V60.4861Z"
			fill="#75BF43"
		/>
		<path
			class="shell-logo-part-2"
			d="M339.77 60.4861C359.732 41.7482 383.96 49.9994 396.308 58.1035C397.619 58.9644 397.201 61.1774 395.792 61.8676C392.392 63.5331 387.5 66.8414 382.162 72.7466C374.182 81.5743 380.5 82.1465 384.656 81.3291C397.202 62.3482 421.655 64.7935 433.393 68.674C434.085 68.903 434.551 69.5604 434.593 70.2886C435.76 90.4767 441.651 86.1388 444.504 81.3291C442.426 76.8335 439.018 64.8997 442.011 53.1294C445.003 41.3591 440.764 35.147 438.27 33.5123C428.295 44.3017 420.814 35.556 418.321 29.8345C410.265 10.0324 428.772 3.28963 444.949 1.8582C451.771 1.25449 458.155 4.7315 461.895 10.4694C468.979 21.3377 479.697 39.7794 490.638 64.1646C505.6 97.5137 496.872 112.39 490.638 115.66C429.792 149.009 364.707 129.555 339.77 115.66V60.4861Z"
			fill="#75BF43"
		/>
		<path
			class="shell-logo-part-3"
			d="M170.442 0.50293L249.825 10.2801L329.208 0.50293L349.053 39.6116L329.208 45.4167L279.593 59.1659L261.608 29.8344L249.825 10.2801L237.731 29.8344L220.056 59.1659L170.442 45.4167L150.596 39.6116L170.442 0.50293ZM170.442 117.829V55.4994L217.265 68.6375L224.397 70.7762L228.428 64.36L249.204 29.8344H250.135L270.911 64.36L274.942 70.7762L282.074 68.6375L329.208 55.4994V117.829L249.825 137.383L170.442 117.829Z"
			fill="#75BF43"
		/>
	</symbol>
</svg>

<!-- Main container with the correct class -->
<div class="shell-app-container">

	<!-- Mobile Header -->
	<div class="shell-mobile-header">
		<button class="shell-menu-button">
			<svg
				fill="none"
				stroke="currentColor"
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="2"
					d="M4 6h16M4 12h16m-7 6h7"
				></path>
			</svg>
		</button>
		<div class="shell-logo-mobile-wrapper">
			<div class="shell-logo-mobile">
				<svg
					width="100%"
					height="100%"
				>
					<use href="#moveright-logo"></use>
				</svg>
			</div>
		</div>
	</div>

	<!-- Sidebar -->
	<aside class="shell-sidebar">
		<div class="shell-logo-desktop-wrapper">
			<div class="shell-logo-desktop">
				<svg
					width="100%"
					height="100%"
				>
					<use href="#moveright-logo"></use>
				</svg>
			</div>
		</div>
		<nav style="margin-top: 2rem;">
			<div class="shell-placeholder nav-0"></div>
		</nav>
		<div
			class="shell-btn-new-opportunity"
			style="margin-top: 1rem; margin-bottom: 1rem;"
		>
			+ New Opportunity
		</div>
		<nav>
			<div class="shell-placeholder nav-1"></div>
			<div class="shell-placeholder nav-2"></div>
			<div class="shell-placeholder nav-3"></div>
			<div
				class="shell-placeholder nav-0"
				style="width: 80%;"
			></div>
		</nav>
	</aside>

	<!-- Main Content -->
	<main class="shell-main-content">
		<!-- Top Bar -->
		<header class="shell-top-bar">
			<div class="shell-placeholder top-bar-left"></div>
			<div class="shell-top-bar-icons">
				<div class="shell-placeholder top-bar-icon"></div>
				<div class="shell-placeholder top-bar-icon"></div>
				<div class="shell-placeholder top-bar-user"></div>
			</div>
		</header>

		<!-- Content Body -->
		<div class="shell-content-body">
			<div class="shell-card">
				<div class="shell-placeholder card-header"></div>
				<div class="shell-placeholder card-body"></div>
			</div>
		</div>
	</main>
</div>